/* */ 
"use strict";
var lang_1 = require('./facade/lang');
var exceptions_1 = require('./facade/exceptions');
var identifiers_1 = require('./identifiers');
var CompilerConfig = (function() {
  function CompilerConfig(genDebugInfo, logBindingUpdate, useJit, renderTypes) {
    if (renderTypes === void 0) {
      renderTypes = null;
    }
    this.genDebugInfo = genDebugInfo;
    this.logBindingUpdate = logBindingUpdate;
    this.useJit = useJit;
    if (lang_1.isBlank(renderTypes)) {
      renderTypes = new DefaultRenderTypes();
    }
    this.renderTypes = renderTypes;
  }
  return CompilerConfig;
}());
exports.CompilerConfig = CompilerConfig;
var RenderTypes = (function() {
  function RenderTypes() {}
  Object.defineProperty(RenderTypes.prototype, "renderer", {
    get: function() {
      return exceptions_1.unimplemented();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(RenderTypes.prototype, "renderText", {
    get: function() {
      return exceptions_1.unimplemented();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(RenderTypes.prototype, "renderElement", {
    get: function() {
      return exceptions_1.unimplemented();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(RenderTypes.prototype, "renderComment", {
    get: function() {
      return exceptions_1.unimplemented();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(RenderTypes.prototype, "renderNode", {
    get: function() {
      return exceptions_1.unimplemented();
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(RenderTypes.prototype, "renderEvent", {
    get: function() {
      return exceptions_1.unimplemented();
    },
    enumerable: true,
    configurable: true
  });
  return RenderTypes;
}());
exports.RenderTypes = RenderTypes;
var DefaultRenderTypes = (function() {
  function DefaultRenderTypes() {
    this.renderer = identifiers_1.Identifiers.Renderer;
    this.renderText = null;
    this.renderElement = null;
    this.renderComment = null;
    this.renderNode = null;
    this.renderEvent = null;
  }
  return DefaultRenderTypes;
}());
exports.DefaultRenderTypes = DefaultRenderTypes;
